import { styled } from 'styled-components';
import { Text } from '../Text';
import { Tag } from '../Tag';
import { Link, MxLink } from '../Link';
import { colors } from '../../abstracts';
import { dontForwardProps } from '../../util';
export const ListContainer = styled.ul.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1hwty5c-0"
})(["display:flex;flex-direction:", ";align-items:start;list-style-type:none;padding:0;"], ({
  orientation
}) => orientation == 'horizontal' ? 'row' : 'column');
export const StepTextGroup = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1hwty5c-1"
})(["margin-left:", "rem;margin-bottom:1.5rem;"], ({
  isLast,
  size
}) => isLast ? 2.125 + (size == 'small' ? 0.438 : 0.688) : 2);
export const StyledStepText = styled(Text).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1hwty5c-2"
})(["max-width:10.063rem;margin-bottom:0.125rem;margin-top:", ";overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:3;line-clamp:3;-webkit-box-orient:vertical;"], ({
  iconSize
}) => iconSize == 'small' ? '-1.125rem' : '-1.563rem');
export const StyledStepSubtext = styled(Text).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1hwty5c-3"
})(["max-width:10.063rem;margin-top:0.125rem;margin-bottom:0.125rem;color:", ";display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"], colors.neutralDeeper);
export const StyledStepTag = styled(Tag).withConfig({
  componentId: "aui__sc-1hwty5c-4"
})(["max-width:10.063rem;margin-top:0.25rem;"]);
export const StyledStepLink = styled(Link).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1hwty5c-5"
})(["margin-top:0.25rem;"]);
export const StyledMxLink = styled(MxLink).withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1hwty5c-6"
})(["margin-top:0.25rem;"]);